import ApiService from '@/services/ApiService';
import Vue from 'vue';

export default {
  getButtonNodeParent(element, counter = 0) {
    const node = element.parentNode
    if(!node || !node.tagName || counter > 10) {
      return null;
    }
    if(node.tagName.toLowerCase() == 'button'
        && !node.classList.contains('no-spinner')
    ) {
      return node;
    }
    return this.getButtonNodeParent(node, counter);
  },
  addLoading(element) {
    // add loading class to element
    if(!element.classList.contains('loader')) {
      element.classList.add('loader');
    }
  },
  removeLoading(element) {
    // remove loading class from element
    if(element.classList.contains('loader')) {
      element.classList.remove('loader');
    }
  },
  getSpinnerStyle(element) {
    const style = window.getComputedStyle(element, null);
    const scrollY = window.pageYOffset + 'px';
    let calculatedHeight = 1*style.getPropertyValue('height').replace('px','')
                              - 1*style.getPropertyValue('padding-top').replace('px','')
                              - 1*style.getPropertyValue('padding-bottom').replace('px','');
    if(calculatedHeight <= 0) {
        calculatedHeight = 1*style.getPropertyValue('height').replace('px','');
    }
    const calculatedWidth = style.getPropertyValue('width').replace('px','');
    let finalHeight = calculatedHeight > 150 ? 150 : calculatedHeight;
    let finalWidth = calculatedWidth > 150 ? 150 : calculatedWidth;
    finalHeight = Math.min(finalHeight, finalWidth)
    finalWidth = Math.min(finalHeight, finalWidth)
    const finalLeft = element.getBoundingClientRect().left +
                      (
                        (style.getPropertyValue('width').replace('px','') - finalWidth) / 2
                      );
    const finalTop = element.getBoundingClientRect().top +
                      (
                        (style.getPropertyValue('height').replace('px','') - finalHeight) / 2
                      );
    return {
      left: `${finalLeft}px`,
      top: `calc(${finalTop}px + ${scrollY})`,
      height: `${finalHeight}px`,
      width: `${finalWidth}px`,
      position: 'absolute',
      'z-index': 9999
    };
  },
  getCategories() {
    return ApiService().get('/categories');
  },
  getHomeData() {
    return ApiService().get('/home');
  },
  getListHistoriesSuggestion() {
    return ApiService().get('/profiles/view-histories');
  },
  checkMobile() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|iPad/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; }(navigator.userAgent || navigator.vendor || window.opera));
    return check;
  },
  generateJWT(username, passwordEncrypted) {
    var sha256 = function sha256(ascii) {
      function rightRotate(value, amount) {
        return (value>>>amount) | (value<<(32 - amount));
      };

      var mathPow = Math.pow;
      var maxWord = mathPow(2, 32);
      var lengthProperty = 'length'
      var i, j; // Used as a counter across the whole file
      var result = ''

      var words = [];
      var asciiBitLength = ascii[lengthProperty]*8;

      //* caching results is optional - remove/add slash from front of this line to toggle
      // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
      // (we actually calculate the first 64, but extra values are just ignored)
      var hash = sha256.h = sha256.h || [];
      // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
      var k = sha256.k = sha256.k || [];
      var primeCounter = k[lengthProperty];
      /*/
      var hash = [], k = [];
      var primeCounter = 0;
      //*/

      var isComposite = {};
      for (var candidate = 2; primeCounter < 64; candidate++) {
        if (!isComposite[candidate]) {
          for (i = 0; i < 313; i += candidate) {
            isComposite[i] = candidate;
          }
          hash[primeCounter] = (mathPow(candidate, .5)*maxWord)|0;
          k[primeCounter++] = (mathPow(candidate, 1/3)*maxWord)|0;
        }
      }

      ascii += '\x80' // Append Ƈ' bit (plus zero padding)
      while (ascii[lengthProperty]%64 - 56) ascii += '\x00' // More zero padding
      for (i = 0; i < ascii[lengthProperty]; i++) {
        j = ascii.charCodeAt(i);
        if (j>>8) return; // ASCII check: only accept characters in range 0-255
        words[i>>2] |= j << ((3 - i)%4)*8;
      }
      words[words[lengthProperty]] = ((asciiBitLength/maxWord)|0);
      words[words[lengthProperty]] = (asciiBitLength)

      // process each chunk
      for (j = 0; j < words[lengthProperty];) {
        var w = words.slice(j, j += 16); // The message is expanded into 64 words as part of the iteration
        var oldHash = hash;
        // This is now the undefinedworking hash", often labelled as variables a...g
        // (we have to truncate as well, otherwise extra entries at the end accumulate
        hash = hash.slice(0, 8);

        for (i = 0; i < 64; i++) {
          var i2 = i + j;
          // Expand the message into 64 words
          // Used below if
          var w15 = w[i - 15], w2 = w[i - 2];

          // Iterate
          var a = hash[0], e = hash[4];
          var temp1 = hash[7]
            + (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) // S1
            + ((e&hash[5])^((~e)&hash[6])) // ch
            + k[i]
            // Expand the message schedule if needed
            + (w[i] = (i < 16) ? w[i] : (
                w[i - 16]
                + (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15>>>3)) // s0
                + w[i - 7]
                + (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2>>>10)) // s1
              )|0
            );
          // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
          var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) // S0
            + ((a&hash[1])^(a&hash[2])^(hash[1]&hash[2])); // maj

          hash = [(temp1 + temp2)|0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
          hash[4] = (hash[4] + temp1)|0;
        }

        for (i = 0; i < 8; i++) {
          hash[i] = (hash[i] + oldHash[i])|0;
        }
      }

      for (i = 0; i < 8; i++) {
        for (j = 3; j + 1; j--) {
          var b = (hash[i]>>(j*8))&255;
          result += ((b < 16) ? 0 : '') + b.toString(16);
        }
      }
      return result;
    };
    let nonce = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 11; i++) {
      nonce += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    const created = Math.floor(Date.now() / 1000);
    const passwordDigest = sha256(nonce + created + passwordEncrypted);
    return `/UsernameToken Email="${username}", PasswordDigest="${passwordDigest}", Nonce="${nonce}", Created="${created}"/`;
  },
  rules() {
    return {
      required: (v) => !!v || Vue.prototype.$gettext("Field is required"),
      email: (v) => /.+@.+\..+/.test(v) || Vue.prototype.$gettext("Invalid email"),
    };
  },
  currentLanguage() {
    return Vue.config.language || 'en_EN';
  },
  isVisible(elem, offset = 0) {
    if (!(elem instanceof Element)) throw Error('DomUtil: elem is not an element.');
    const style = getComputedStyle(elem);
    if (style.display === 'none') {
      return false;
    }
    if (style.visibility !== 'visible') {
      return false;
    }
    if (style.opacity < 0.1) {
      return false;
    }
    if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height +
        elem.getBoundingClientRect().width === 0) {
        return false;
    }
    const elemCenter = {
        x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
        y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
    };
    if (elemCenter.x < 0) {
      return false;
    }
    if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) {
      return false;
    }
    if (elemCenter.y < 0) {
      return false;
    }
    if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) {
      return false;
    }
    const points = document.elementsFromPoint(elemCenter.x, elemCenter.y);
    if(typeof points[offset] === 'undefined') return false
    let pointContainer = points[offset];
    do {
      if (pointContainer === elem || pointContainer === elem.parentNode) return true;
    } while (pointContainer = pointContainer.parentNode);
    return false;
}
};
